import React,{ useEffect, useState } from 'react'
import "./css/Dashboard.css";
import AllOrder from "./AllOrder";
import { Cancel, Check, CreditCard, Layers, LocalShipping, Pending, ShoppingCart, ShoppingCartTwoTone, Today } from '@mui/icons-material';
import Trending from './Trending';
import { firestore, auth } from '../firebase';
import { useStateValue } from './StateProvider'
import { useHistory, Redirect } from 'react-router-dom'

function Dashboard({order}) {
  const history = useHistory();
  const [productIds, setProductIds] = useState([]);
  const [theProducts, setTheProducts] = useState([]);
  const [{basket, user}, dispatch] = useStateValue();

  useEffect(() => {
    const userStoriesRef = firestore.collection('orders');

    const unsubscribe = userStoriesRef.onSnapshot((querySnapshot) => {
      const ids = [];
      const userStoriesData = [];

      querySnapshot.forEach((doc) => {
        ids.push(doc.id);
        const data = doc.data();
        userStoriesData.push(data);
      });

      setProductIds(ids);
      setTheProducts(userStoriesData);
    });

    return () => {
      unsubscribe();
    };
  }, []);

  const todayDate = new Date().toLocaleDateString();
  const ordersToday = theProducts.filter(order => {
    const orderDate = order?.orderDate?.toDate();
    return orderDate && orderDate.toLocaleDateString() === todayDate && order?.status !== "Canceled";
  });

  const ordersPending = theProducts.filter(order => order.status === "Pending");
  const ordersDelivered = theProducts.filter(order => order.status === "Delivered");
  const ordersCanceled = theProducts.filter(order => order.status === "Canceled");
  const allTimeSales = theProducts
  .filter(order => order?.status === "Delivered")
  .reduce((total, order) => total + (parseFloat(order?.price) || 0), 0);
const formattedAllTimeSales = typeof allTimeSales === 'number' ? allTimeSales.toFixed(2) : '0.00';

const todayOrders = theProducts
  .filter(order => order?.status === "Delivered")
  .filter(order => {
    const orderDate = order?.orderDate?.toDate();
    return orderDate && orderDate.toLocaleDateString() === todayDate;
  });

const yesterdayOrders = theProducts
  .filter(order => order?.status === "Delivered")
  .filter(order => {
    const orderDate = order?.orderDate?.toDate();
    const yesterday = new Date(new Date().setDate(new Date().getDate() - 1)).toLocaleDateString();
    return orderDate && orderDate.toLocaleDateString() === yesterday;
  });

const thisMonthOrders = theProducts
  .filter(order => order?.status === "Delivered")
  .filter(order => {
    const orderDate = order?.orderDate?.toDate();
    const startOfMonth = new Date(new Date().getFullYear(), new Date().getMonth(), 1).toLocaleDateString();
    return orderDate && orderDate >= new Date(startOfMonth);
  });


const calculateTrendingProducts = () => {
  const trendingProductsMap = new Map();

  theProducts.forEach((order) => {
    if (order.status === 'Delivered') {
      const productId = order?.itemOrdered;

      if (trendingProductsMap.has(productId)) {
        trendingProductsMap.set(productId, trendingProductsMap.get(productId) + 1);
      } else {
        trendingProductsMap.set(productId, 1);
      }
    }
  });

  const trendingProducts = Array.from(trendingProductsMap, ([productId, quantity]) => ({
    id: productId,
    quantity,
    itemOrdered: theProducts.find((order) => order.itemOrdered === productId)?.itemOrdered,
    image: theProducts.find((order) => order.itemOrdered === productId)?.image,
    productDesc: theProducts.find((order) => order.itemOrdered === productId)?.productDesc,
  }));

  return trendingProducts;
};

const trendingProducts = calculateTrendingProducts();

  return (
    <div className='dashboard'>
      <h3>Dashboard Overview</h3>

      <div className='first-line'>
        <div className='first'>
          <ShoppingCartTwoTone sx={{color: "orange", border: "2px solid", borderRadius: "50%", padding: "5px", fontSize: "35px"}}/>
          <div className='first-p'>
            <p>Orders Today</p>
            <p>{ordersToday.length}</p>
          </div>
        </div>
        <div className='first'>
          <LocalShipping sx={{color: "lightblue", border: "2px solid", borderRadius: "50%", padding: "5px", fontSize: "35px"}}/>
          <div className='first-p'>
            <p>Orders Pending</p>
            <p>{ordersPending.length}</p>
          </div>
        </div>
        <div className='first'>
          <Check  sx={{color: "green", border: "2px solid", borderRadius: "50%", padding: "5px", fontSize: "35px"}}/>
          <div className='first-p'>
            <p>Orders Delivered</p>
            <p>{ordersDelivered.length}</p>
          </div>
        </div>
        <div className='first'>
          <Cancel  sx={{color: "red", border: "2px solid", borderRadius: "50%", padding: "5px", fontSize: "35px"}}/>
          <div className='first-p'>
            <p>Orders Canceled</p>
            <p>{ordersCanceled.length}</p>
          </div>
        </div>
        <div className='first'>
          <ShoppingCart sx={{color: "orange", border: "2px solid", borderRadius: "50%", padding: "5px", fontSize: "35px"}}/>
          <div className='first-p'>
            <p>Orders Alltime</p>
            <p>{productIds?.length}</p>
          </div>
        </div>
      </div>

      <div className='second-line'>
        <div className='second'>
          <Today sx={{color: "orange", border: "2px solid", borderRadius: "50%", padding: "5px", fontSize: "35px"}}/>
          <p>Today Orders</p>
          <p>${todayOrders.reduce((total, order) => total + (parseFloat(order?.price) || 0), 0).toFixed(2)}</p>
        </div>
       <div className='second'>
         <Layers sx={{color: "orange", border: "2px solid", borderRadius: "50%", padding: "5px", fontSize: "35px"}}/>
         <p>Yesterday Orders</p>
         <p>${yesterdayOrders.reduce((total, order) => total + (parseFloat(order?.price) || 0), 0).toFixed(2)}</p>
        </div>
       <div className='second'>
         <ShoppingCart sx={{color: "orange", border: "2px solid", borderRadius: "50%", padding: "5px", fontSize: "35px"}}/>
         <p>This Month</p>
         <p>${thisMonthOrders.reduce((total, order) => total + (parseFloat(order?.price) || 0), 0).toFixed(2)}</p>
        </div>
       <div className='second'>
         <CreditCard sx={{color: "orange", border: "2px solid", borderRadius: "50%", padding: "5px", fontSize: "35px"}}/>
         <p>All Time Sales</p>
         <p>${formattedAllTimeSales}</p>
        </div>
      </div>

      <br />

      <div className="trending">
        <h3>Trending Products</h3>
        <div className="trending-rows">
        {trendingProducts.map((item, index) => (
            <Trending key={index} item={item} />
          ))}
        </div>
      </div>

      <br />

      <AllOrder />
    </div>
  )
}

export default Dashboard
